import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { fileUrl } from "../lib/api";

export function HomeCollectionBanner() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/collections-featured").then((r) => setC(r.data?.id ? r.data : null)); }, []);
  if (!c) return null;
  const banner = c.banner_image?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${c.banner_image}` : c.banner_image;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24" data-testid="home-collection-banner">
      <Link to={`/collections/${c.slug}`} data-testid="home-collection-link" className="relative block overflow-hidden bg-[#0a192f] text-white min-h-[360px] group">
        {banner && <img src={banner} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:scale-105 transition-transform duration-[1200ms]" />}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a192f] via-[#0a192f]/70 to-transparent" />
        <div className="relative grid lg:grid-cols-[3fr_2fr] gap-10 p-10 lg:p-16 items-end min-h-[360px]">
          <div>
            {c.season_label && <div className="overline text-[#d4af37]" data-testid="home-collection-season">{c.season_label}</div>}
            <h2 className="font-serif text-4xl lg:text-6xl mt-3 leading-[1.05] tracking-tight" data-testid="home-collection-title">{c.name}</h2>
            {c.tagline && <p className="text-white/80 text-lg mt-5 max-w-xl">{c.tagline}</p>}
            <span className="btn-gold inline-flex items-center gap-2 mt-8">Explore the collection <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
          </div>
          <div className="hidden lg:flex justify-end -space-x-8">
            {c.products.slice(0, 3).map((p, i) => (
              <div key={p.id} style={{ transform: `rotate(${(i - 1) * 5}deg) translateY(${Math.abs(i - 1) * 10}px)` }} className="w-32 h-44 bg-[#f4f5f7] overflow-hidden shadow-2xl border-2 border-[#0a192f]">
                {p.cover_key ? <img src={fileUrl(p.cover_key)} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-serif text-3xl text-[#0a192f]">{p.name?.[0]}</div>}
              </div>
            ))}
          </div>
        </div>
      </Link>
    </section>
  );
}
